









































import { mapGetters, mapActions } from 'vuex'
import MainNavbar from '@/components/MainNavbar.vue'

export default {
  name: 'RiskAssessment',
  components: {
    MainNavbar
  },
  data () {
    return {
      selections: []
    }
  },
  computed: {
    ...mapGetters([
      'sessionUserIsAdmin',
      'sessionUserIsBankOrAdmin',
      'currentCustomerId',
      'sessionUserHomePage',
      'riskLevels',
      'currentAssessment',
      'currentQuarter',
      'currentYear'
    ]),
    riskQuestions () {
      return (this.currentAssessment) ? this.currentAssessment.questions : []
    },
    // riskQuestionsOptions () {
    //   const options = []
    //   for (let q=0; q<this.riskQuestions.length; q++) {
    //     options.push({
    //       value: 
    //     })
    //   }
    //   return options
    // },
    feedback () {
      const feedback = []
      let a: number
      for (let q=0; q<this.riskQuestions.length; q++) {
        if (!(typeof this.selections[q] === 'undefined' || this.selections[q] === null)) {
          a = this.selections[q]
          feedback.push(this.riskQuestions[q].options[a].feedback)
        } else {
          feedback.push('')
        }
      }
      return feedback
    },
    formIncomplete () {
      if (this.selections.length !== this.riskQuestions.length) {
        return true
      }
      for (let s=0; s<this.selections.length; s++) {
        if (this.selections[s] === null) {
          return true
        }
      }
      return false
    },
    unansweredQuestion () {
      if (Array.isArray(this.selections)) {
        if (this.selections.length !== this.riskQuestions.length) {
          return 1
        }
        for (let s=0; s<this.selections.length; s++) {
          if (this.selections[s] === null) {
            return s+1
          }
        }
      }
      return null
    },
  },
  methods: {
    ...mapActions([
      'getAssessment',
      'getAssessmentHistory',
      'postAssessmentAnswers'
    ]),
    chooseAnswer (q: number, a: number) {
      this.$set(this.selections, q, a)
    },
    async submitAnswers () {
      const result = await this.postAssessmentAnswers({
        customer_id: this.currentCustomerId,
        assessment_id: this.currentAssessment.id,
        answers: this.selections,
        period: this.currentYear
      })
      if (!result.success) {
        alert(result.message)
        return false
      }
      if (this.sessionUserIsAdmin && this.currentCustomerId) {
        this.$router.push('/admin/customers/'+this.currentCustomerId)
        return
      }
      if (this.sessionUserIsBankOrAdmin && this.currentCustomerId) {
        this.$router.push('/customers/'+this.currentCustomerId)
        return
      }
      this.$router.push(this.sessionUserHomePage)
    }
  },
  async mounted () {
    if (this.sessionUserIsBankOrAdmin && !this.currentCustomerId) {
      this.$router.push(this.sessionUserHomePage)
    }
    this.getAssessment('default')
  },
  watch: {
    riskQuestions () {
      this.selections.length = this.riskQuestions.length
      for (let q=0; q<this.riskQuestions.length; q++) {
        if (typeof this.selections[q] === 'undefined') {
          this.selections[q] = null
        }
      }
    }
  }
}
